import { Component, Input } from "@angular/core";

import { ApiService } from "src/app/api.service";
import { APIResults, AssemblyConfig } from "src/app/sharedinterfaces";

@Component({
	selector: "app-health-split-asset",
	templateUrl: "./health-split-asset.component.html",
	styleUrls: ["./health-split-asset.component.scss"]
})
export class HealthSplitAssetComponent {
	@Input()
	asset: APIResults.FleetAsset;

	@Input()
	noLink = false;

	constructor(public api: ApiService) { }

	get rtbHealth(): number {
		return this.asset.rtbhealth;
	}

	get fdmHealth(): number {
		let himax = (this.asset.exceedancecount > 0) ? AssemblyConfig.HumsHiThreshold.Warning : 0;
		himax = Math.max(himax, (this.asset.severeexceedancecount > 0) ? AssemblyConfig.HumsHiThreshold.Alarm : 0);
		return himax;
	}

	get mdHealth(): number {
		const obcuHealth = 0; // TODO: Temporarily turning off obcu health alerts // this.asset.latest_obcu_failures > 0 ? AssemblyConfig.HumsHiThreshold.Alarm : 0;
		return Math.max(this.asset.mdmax, obcuHealth);
	}

	get overallHealth(): number {
		return Math.max(this.rtbHealth, this.fdmHealth, this.mdHealth);
	}

	get healthText(): string {
		if (this.overallHealth >= AssemblyConfig.HumsHiThreshold.Warning) {
			return "Attention needed";
		} else {
			return "Normal Conditions";
		}
	}

	backgroundClass(health: number): string {
		if (health >= AssemblyConfig.HumsHiThreshold.Alarm) {
			return "status-error-bg"
		} else if (health >= AssemblyConfig.HumsHiThreshold.Warning) {
			return "status-warning-bg"
		} else {
			return "status-ok-bg";
		}
	}

	get iconClass(): string {
		if (this.overallHealth >= AssemblyConfig.HumsHiThreshold.Warning) {
			return "icon-attention-alt"
		} else {
			return "icon-ok";
		}
	}
}
